import { Tabs, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { Route, matchPath } from 'react-router-dom';
import { find } from 'lodash';

import history from 'Src/common/utilities/history';
import { CONNECTIONS_TAB_KEY, MENTORS_TAB_KEY, ROUTES_MAPPING, SETTINGS_TAB_KEY, TABS_CONFIG } from '../../constants';
import Mentors from './mentors';
import Connections from './connections';
import Settings from './settings';
import VerificationWrapper from '../verificationWrapper';
import { checkParams } from '../../utils';
import './style.scss';

const TabComponentMapping = {};
TabComponentMapping[SETTINGS_TAB_KEY] = Settings;
TabComponentMapping[MENTORS_TAB_KEY] = Mentors;
TabComponentMapping[CONNECTIONS_TAB_KEY] = Connections;

function Dashboard() {
  const [activeTab, setActiveTab] = useState(SETTINGS_TAB_KEY);

  useEffect(() => {
    ROUTES_MAPPING.map((route) => {
      const matchedPath = matchPath(history.location.pathname, {
        path: route.value,
        exact: true,
      });

      if (matchedPath) {
        setActiveTab(route.key);
      }
    });

    checkParams({
      name: 'new_user',
      callback: () =>
        notification.success({
          message: `Welcome to ${window.programDetails.name}`,
          description: 'Feel free to explore and connect with members',
        }),
    });
  }, [window.location.pathname]);

  const handleTabChange = (key) => {
    setActiveTab(key);

    const route = find(ROUTES_MAPPING, (item) => item.key === key).value;
    history.push(route);
  };

  return (
    <VerificationWrapper>
      <div className="mentorship-dashboard-wrapper">
        <Tabs activeKey={activeTab} onChange={handleTabChange} className="mentorship-admin-tabs">
          {TABS_CONFIG.map(({ path, key, title }) => {
            const Component = TabComponentMapping[key];

            return (
              <Tabs.TabPane tab={title} key={key}>
                <Route exact path={path} component={Component} />
              </Tabs.TabPane>
            );
          })}
        </Tabs>
      </div>
    </VerificationWrapper>
  );
}

export default Dashboard;
